// Export common event names as constants
export const ANALYTICS_EVENTS = {
  // App lifecycle
  APP_OPENED: "App Opened",
  APP_BACKGROUNDED: "App Backgrounded",

  // Authentication
  LOGIN_STARTED: "Login Started",
  LOGIN_COMPLETED: "Login Completed",
  LOGIN_FAILED: "Login Failed",
  LOGOUT: "Logout",
  AUTH0_LOGIN_STARTED: "Auth0 Login Started",
  AUTH0_LOGIN_COMPLETED: "Auth0 Login Completed",
  AUTH0_LOGIN_FAILED: "Auth0 Login Failed",
  LEGACY_LOGIN_STARTED: "Legacy Login Started",
  LEGACY_LOGIN_COMPLETED: "Legacy Login Completed",
  LEGACY_LOGIN_FAILED: "Legacy Login Failed",
  FORGOT_PASSWORD_CLICKED: "Forgot Password Clicked",
  FORGOT_PASSWORD_SENT: "Forgot Password Sent",
  FORGOT_PASSWORD_FAILED: "Forgot Password Failed",
  CONTACT_US_CLICKED: "Contact Us Clicked",
  AUTH0_UPSELL_BANNER_VIEWED: "Auth0 Upsell Banner Viewed",
  AUTH0_UPSELL_BANNER_CLICKED: "Auth0 Upsell Banner Clicked",
  BIOMETRIC_SETUP_STARTED: "Biometric Setup Started",
  BIOMETRIC_SETUP_ENABLED: "Biometric Setup Enabled",
  BIOMETRIC_SETUP_SKIPPED: "Biometric Setup Skipped",
  PIN_SETUP_STARTED: "PIN Setup Started",
  PIN_SETUP_COMPLETED: "PIN Setup Completed",
  PIN_SETUP_FAILED: "PIN Setup Failed",

  // Biometric verification (returning users)
  BIOMETRIC_VERIFY_STARTED: "Biometric Verify Started",
  BIOMETRIC_VERIFY_SUCCESS: "Biometric Verify Success",
  BIOMETRIC_VERIFY_FAILED: "Biometric Verify Failed",

  // PIN verification (returning users)
  PIN_VERIFY_SUCCESS: "PIN Verify Success",
  PIN_VERIFY_FAILED: "PIN Verify Failed",

  // Navigation
  SCREEN_VIEWED: "Screen Viewed",
  TAB_SELECTED: "Tab Selected",

  // User actions
  BUTTON_CLICKED: "Button Clicked",
  ITEM_SELECTED: "Item Selected",
  SEARCH_PERFORMED: "Search Performed",

  // Camera interactions
  CAMERA_SEARCHED: "Camera Searched",
  CAMERA_CLICKED: "Camera Clicked",
  CAMERA_VIEW_CLIPS_CLICKED: "Camera View Clips Clicked",
  CAMERA_VIEW_LIVESTREAM_CLICKED: "Camera View Livestream Clicked",
  CAMERA_NOTIFICATION_SETTINGS_CLICKED: "Camera Notification Settings Clicked",

  // Alarm settings
  ALARM_ROUTINE_EDITED: "Alarm Routine Edited",
  ALARM_ROUTINE_SAVED: "Alarm Routine Saved",
  ALARM_RESPONSE_EDITED: "Alarm Response Edited",
  ALARM_RESPONSE_SAVED: "Alarm Response Saved",
  ALARM_EXCEPTION_EDITED: "Alarm Exception Edited",
  ALARM_EXCEPTION_SAVED: "Alarm Exception Saved",
  ALARM_OVERRIDE_EDITED: "Alarm Override Edited",
  ALARM_OVERRIDE_SAVED: "Alarm Override Saved",
  ALARM_SILENCE_EDITED: "Alarm Silence Edited",
  ALARM_SILENCE_SAVED: "Alarm Silence Saved",

  MONITORING_UPGRADE_REQUESTED: "Monitoring Upgrade Requested",

  // AI Scheduler Agent
  AI_AGENT_ENTERED: "AI Agent Entered",
  AI_AGENT_MESSAGE_SENT: "AI Agent Message Sent",
  AI_AGENT_PREVIEW_CLICKED: "AI Agent Preview Clicked",
  AI_AGENT_APPLY_ALL_CLICKED: "AI Agent Apply All Clicked",

  // JPEG Stream (G1 cameras)
  JPEG_STREAM_VIEWED: "JPEG Stream Viewed",
  JPEG_STREAM_STARTED: "JPEG Stream Started",
  JPEG_STREAM_ERROR: "JPEG Stream Error",
  JPEG_STREAM_TIMEOUT: "JPEG Stream Timeout",

  // MP4 Stream (G2 cameras)
  MP4_STREAM_VIEWED: "MP4 Stream Viewed",
  MP4_STREAM_STARTED: "MP4 Stream Started",
  MP4_STREAM_ERROR: "MP4 Stream Error",

  // Livestream (native MJPEG)
  LIVESTREAM_VIEWED: "Livestream Viewed",
  LIVESTREAM_STARTED: "Livestream Started",
  LIVESTREAM_ERROR: "Livestream Error",
  LIVESTREAM_TIMEOUT: "Livestream Timeout",
  LIVESTREAM_STILL_WATCHING_PROMPTED: "Livestream Still Watching Prompted",
  LIVESTREAM_STILL_WATCHING_CONTINUED: "Livestream Still Watching Continued",
  LIVESTREAM_STILL_WATCHING_STOPPED: "Livestream Still Watching Stopped",

  // API Errors (non-fatal)
  API_ERROR: "API Error",

  // API Performance
  API_REQUEST_COMPLETED: "API Request Completed",
} as const;
